export async function invoiceErrorMessage(error, fallback) {
  let data = error.response && error.response.data
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      data = data.size <= 65536 ? JSON.parse(await data.text()) : null
    } catch (ignored) {
      data = null
    }
  }
  return data && typeof data.details === 'string' ? data.details : fallback
}

export async function invoicePdf(response) {
  const blob = response.data
  const contentType = (response.headers && response.headers['content-type']) || (blob && blob.type) || ''
  if (typeof Blob !== 'undefined' && blob instanceof Blob && !/json/i.test(contentType) && await blob.slice(0, 5).text() === '%PDF-') return blob
  const error = new Error('The server did not return a PDF')
  error.response = response
  throw error
}

export function invoiceFilename(payment, invoice) {
  if (invoice && invoice.schema_version === 2) {
    if (invoice.stage === 'draft') return `funding-batch-${invoice.batch_id}-draft.pdf`
    return `${invoice.invoice_number}.pdf`
  }
  return `${payment.number || `Payment ${payment.id}`}.pdf`
}

export function downloadInvoicePdf(blob, payment, invoice) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  try {
    link.href = url
    link.download = invoiceFilename(payment, invoice)
    document.body.appendChild(link)
    link.click()
  } finally {
    link.remove()
    URL.revokeObjectURL(url)
  }
}
